// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { AssetInfoFragmentDoc } from '../../projects/assets/AssetPreview.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type TradesPunchlistPdfQueryVariables = Types.Exact<{
  punchlistItemIds: Array<Types.Scalars['ID']['input']> | Types.Scalars['ID']['input'];
}>;


export type TradesPunchlistPdfQuery = { __typename?: 'Query', punchlistItemTodos: Array<{ __typename?: 'PunchlistItemTodo', id: string, name: string, description?: string | null | undefined, dueDate?: Types.Scalars['Date']['input'] | null | undefined, createdAt: Types.Scalars['DateTime']['input'], location?: { __typename?: 'Location', id: string, name: string } | null | undefined, attachments: Array<{ __typename?: 'Attachment', id: string, asset: { __typename?: 'Asset', id: string, version: string, contentType: string, downloadUrl: string, attachmentUrl: string, fileName?: string | null | undefined, createdAt: Types.Scalars['DateTime']['input'], previewUrl?: string | null | undefined } }>, parent?:
      | { __typename?: 'StandaloneProject', id: string, name: string }
      | { __typename?: 'Region', id: string, name: string }
      | { __typename?: 'Cohort' }
      | { __typename?: 'Development' }
      | { __typename?: 'Market', id: string, name: string }
      | { __typename?: 'Community', id: string, name: string }
      | { __typename?: 'Subdivision', id: string, name: string }
      | { __typename?: 'Lot', id: string, name: string }
      | { __typename?: 'Structure', id: string, name: string }
      | { __typename?: 'Unit', id: string, name: string }
     | null | undefined, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined }> };

export type PunchlistItemTodos_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string };

export type PunchlistItemTodos_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string };

export type PunchlistItemTodos_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string };

export type PunchlistItemTodos_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string };

export type PunchlistItemTodos_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string };

export type PunchlistItemTodos_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string };

export type PunchlistItemTodos_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string };

export type PunchlistItemTodos_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string };

export type PunchlistItemTodos_ProjectFragment =
  | PunchlistItemTodos_Project_StandaloneProject_Fragment
  | PunchlistItemTodos_Project_Region_Fragment
  | PunchlistItemTodos_Project_Market_Fragment
  | PunchlistItemTodos_Project_Community_Fragment
  | PunchlistItemTodos_Project_Subdivision_Fragment
  | PunchlistItemTodos_Project_Lot_Fragment
  | PunchlistItemTodos_Project_Structure_Fragment
  | PunchlistItemTodos_Project_Unit_Fragment
;

export const PunchlistItemTodos_ProjectFragmentDoc = gql`
    fragment PunchlistItemTodos_Project on Project {
  id
  name
}
    `;
export const TradesPunchlistPdfDocument = gql`
    query TradesPunchlistPdf($punchlistItemIds: [ID!]!) {
  punchlistItemTodos(filter: {id: $punchlistItemIds}) {
    id
    name
    description
    dueDate
    createdAt
    location {
      id
      name
    }
    attachments {
      id
      asset {
        ...AssetInfo
      }
    }
    parent {
      ...PunchlistItemTodos_Project
    }
    tradePartner {
      id
      name
    }
  }
}
    ${AssetInfoFragmentDoc}
${PunchlistItemTodos_ProjectFragmentDoc}`;

/**
 * __useTradesPunchlistPdfQuery__
 *
 * To run a query within a React component, call `useTradesPunchlistPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useTradesPunchlistPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTradesPunchlistPdfQuery({
 *   variables: {
 *      punchlistItemIds: // value for 'punchlistItemIds'
 *   },
 * });
 */
export function useTradesPunchlistPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables> & ({ variables: TradesPunchlistPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>(TradesPunchlistPdfDocument, options);
      }
export function useTradesPunchlistPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>(TradesPunchlistPdfDocument, options);
        }
// @ts-ignore
export function useTradesPunchlistPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>;
export function useTradesPunchlistPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<TradesPunchlistPdfQuery | undefined, TradesPunchlistPdfQueryVariables>;
export function useTradesPunchlistPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>(TradesPunchlistPdfDocument, options);
        }
export type TradesPunchlistPdfQueryHookResult = ReturnType<typeof useTradesPunchlistPdfQuery>;
export type TradesPunchlistPdfLazyQueryHookResult = ReturnType<typeof useTradesPunchlistPdfLazyQuery>;
export type TradesPunchlistPdfSuspenseQueryHookResult = ReturnType<typeof useTradesPunchlistPdfSuspenseQuery>;
export type TradesPunchlistPdfQueryResult = ApolloReactCommon.QueryResult<TradesPunchlistPdfQuery, TradesPunchlistPdfQueryVariables>;